import { Account } from '../../../../../assets/constant/accountManager.type';
import React, { useEffect, useState } from 'react';
import { logic } from '../../../../../../logic';
import { ConnectedWallet } from '../../../../../assets/constant/kit.type';
import ModalTemplateB from '../../../../../components/_template/modal/ModalTemplateB';
import Select from '../../../../../components/_atom/select/Select';
import EQConnectWalletButtonWithMetamask from '../../../../../../modules/EQConnect/EQConnectWalletButtonWithMetamask';
import CommentInput from '../../../../../components/_atom/input/CommentInput';
import BasicButton from '../../../../../components/_atom/button/BasicButton';
import { ButtonTheme } from '../../../../../components/_atom/button/StyledButton';
import toast from 'react-hot-toast';
import BasicTable from '../../../../../components/_atom/table/BasicTable';
import CopyToClipboard from 'react-copy-to-clipboard/lib';
import iconCopy from '../../../../dashboard/assets/Icon_copy_address.png';
import EnterPinCodeModal from '../../EnterPinCodeModal';

const AccountDepositCoinModal = (props: { account?: Account; isOpen: boolean; closeModal: () => void }) => {
  const { account, isOpen, closeModal } = props;
  const { address } = account || {};
  const [networks, setNetworks] = useState<any[]>([]);
  const getNetworks = async () => {
    const { result, error } = await logic.microChain.getMyProjectNetworkDetail();
    if (error) {
      return;
    }
    setNetworks(result);
  };
  const parsedNetworks = networks.map((network) => ({
    label: network.network_detail?.label,
    value: network,
  }));
  const [selectedNetwork, setSelectedNetwork] = useState<any>();
  const [selectedCoin, setSelectedCoin] = useState<{
    currency_id: number;
    name: string;
    image: string;
    unit: string;
    symbol: string;
    origin_network_id: number;
    origin_micro_chain_id: number;
    origin_owner_id: number;
    type: number;
    main_status: number;
    sub_status: number;
    currency_detail: { initial_supply: string; official_site: string; mintable: boolean; burnable: boolean };
  }>();
  const getCoinInfos = async () => {
    const { result: currencyInfos, error: coinInfosError } = await logic.currency.getCoinInfos({ originMicroChainIds: [selectedNetwork.micro_chain_id] });
    if (coinInfosError) {
      return;
    }
    const coinInfo = currencyInfos ? currencyInfos[0] : undefined;
    setSelectedCoin(coinInfo);
  };
  useEffect(() => {
    if (selectedNetwork) {
      getCoinInfos();
    }
  }, [selectedNetwork]);
  const [connectedWallet, setConnectedWallet] = useState<ConnectedWallet>({
    connectWalletType: '',
    connectAddress: '',
  });

  const [txHash, setTxHash] = useState<string>('');
  const depositCoinWithMetamask = async () => {
    const { result, error } = await logic.nftKit.coinTransferWithMetamask(address as string, Number(amount));
    if (error) {
      toast.error('Failed to deposit coin');
      return;
    }
    toast.success('Coin deposited successfully');
    setTxHash(result);
  };
  const depositCoinWithServer = async (password: string) => {
    if (!selectedCoin?.origin_micro_chain_id || password.length !== 6) {
      return;
    }
    const { result, error } = await logic.nftKit.coinTransferWithServer(selectedCoin?.origin_micro_chain_id, password, address as string, Number(amount));
    if (error) {
      toast.error('Failed to deposit coin');
      return;
    }
    toast.success('Coin deposited successfully');
    const { transaction_hash } = result;
    setTxHash(transaction_hash);
  };
  const [password, setPassword] = useState<string>('');
  const [isOpenEnterPinModal, setIsOpenEnterPinModal] = useState<boolean>(false);
  const depositCoin = async () => {
    if (connectedWallet.connectWalletType === 'metamask') {
      depositCoinWithMetamask();
    } else {
      if (password?.length !== 6) {
        setIsOpenEnterPinModal(true);
        return;
      }
      depositCoinWithServer(password as string);
    }
  };

  const [coinBalance, setCoinBalance] = useState<string>();
  const getCoinBalance = async () => {
    if (!selectedNetwork || !connectedWallet?.connectAddress) {
      return;
    }
    const { result, error } = await logic.tokenKit.getCoinBalance(selectedNetwork.micro_chain_id, [connectedWallet?.connectAddress]);
    if (error) {
      return;
    }
    const currentBalance = result?.find((balance) => balance.address === connectedWallet?.connectAddress);
    setCoinBalance(currentBalance?.balance);
  };
  useEffect(() => {
    getCoinBalance();
  }, [selectedNetwork, connectedWallet]);

  const [amount, setAmount] = useState<string>('');
  useEffect(() => {
    if (isOpen) {
      getNetworks();
    }
    setAmount('');
    setSelectedNetwork(undefined);
    setSelectedCoin(undefined);
    setConnectedWallet({ connectWalletType: '', connectAddress: '' });
    setCoinBalance('');
    setTxHash('');
  }, [isOpen]);
  return (
    <ModalTemplateB isOpen={isOpen} onRequestClose={closeModal} title="Deposit Coin" isDisplayClose showDivideLine={false}>
      <EnterPinCodeModal
        isOpen={isOpenEnterPinModal}
        closeModal={async () => {
          setIsOpenEnterPinModal(false);
          if (password.length === 6) {
            depositCoinWithServer(password).finally(() => {
              setPassword('');
              setIsOpenEnterPinModal(false);
            });
          }
        }}
        connectedWallet={connectedWallet}
        pin={password}
        setPin={setPassword}
      />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 40, paddingLeft: 10, width: 810 }}>
        <div className="kit-label-value-wrapper column">
          <div className="kit-label">Receiver</div>
          <div className="kit-value" style={{ paddingLeft: 10 }}>
            {address}
          </div>
        </div>
        <div className="kit-label-value-wrapper column">
          <div className="kit-label">
            Network
            <div className="kit-label required">*</div>
          </div>
          <Select
            options={parsedNetworks}
            selectedValue={selectedNetwork}
            setSelectedValue={(el) => {
              setSelectedNetwork(el);
            }}
            canSelect={networks.length !== 0}
            placeholder={'Select network'}
            isAbsolute={true}
          />
        </div>
        <div className="kit-label-value-wrapper column">
          <div className="kit-label">Coin</div>
          <div className="kit-value" style={{ paddingLeft: 10, gap: 5 }}>
            {selectedCoin ? (
              <>
                <img src={selectedCoin?.image} style={{ width: 19, height: 19, objectFit: 'contain', borderRadius: 50 }} alt={selectedCoin?.name} />
                {selectedCoin?.symbol}
              </>
            ) : (
              '-'
            )}
          </div>
        </div>
        <div className="kit-label-value-wrapper column">
          <div className="kit-label">
            Sender
            <div className="kit-label required">*</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, paddingLeft: 10 }}>
            {connectedWallet?.connectAddress && <div className="connected-address-label">{connectedWallet?.connectAddress}</div>}
            <EQConnectWalletButtonWithMetamask connectedWallet={connectedWallet} setConnectedWallet={setConnectedWallet} type={'compact'} />
          </div>
          {connectedWallet.connectAddress && (
            <div style={{ fontSize: 12, lineHeight: '100%', color: '#B1B1C1', paddingLeft: 10 }}>
              Balance : {coinBalance} {selectedCoin?.unit}
            </div>
          )}
        </div>
        <div className="kit-label-value-wrapper column">
          <div className="kit-label">
            Amount
            <div className="kit-label required">*</div>
          </div>
          <CommentInput
            value={amount}
            style={{ paddingLeft: 10 }}
            placeholder={'Enter amount'}
            onChange={(e) => {
              const regex = /^\d*\.?\d*$/;
              if (e.target.value === '' || regex.test(e.target.value)) {
                setAmount(e.target.value);
              }
            }}
            isValid={coinBalance ? Number(amount) <= Number(coinBalance) : true}
            message={coinBalance && Number(amount) > Number(coinBalance) ? 'Please enter less than your balance' : ''}
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            fontSize: 14,
            lineHeight: '20px',
            letterSpacing: '-1%',
            whiteSpace: 'pre-line',
            textAlign: 'center',
          }}
        >
          {'Gas fee required. \n Please ensure sufficient balance.'}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10 }}>
          <BasicButton theme={ButtonTheme.NORMAL} onClick={closeModal}>
            Close
          </BasicButton>
          <BasicButton
            onClick={depositCoin}
            disabled={!selectedNetwork || !amount || !connectedWallet.connectAddress || (coinBalance ? Number(amount) > Number(coinBalance) : false)}
          >
            Send
          </BasicButton>
        </div>
        {txHash && (
          <div className="method-result-wrapper">
            <div className="method-result-text" style={{ marginBottom: 10 }}>
              Sent (Transaction Submitted)
            </div>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
              }}
            >
              <div className="method-result-text">TX Hash : {txHash}</div>
              <CopyToClipboard text={txHash} onCopy={() => toast('Copied TX Hash', { icon: '👏' })}>
                <img
                  src={iconCopy}
                  alt="copy"
                  style={{
                    width: 20,
                    height: 20,
                    objectFit: 'contain',
                    cursor: 'pointer',
                  }}
                />
              </CopyToClipboard>
            </div>
          </div>
        )}
      </div>
    </ModalTemplateB>
  );
};

export default AccountDepositCoinModal;
